export default "__VITE_ASSET__CsK5D7B4__"